import { useMemo } from 'react';
import {
  getCategories,
  getUsersConditional,
  getVendors,
  getWarehousesPaginated,
} from '../../utils/apiUtils/inventoryUtils';

const usePODropdowns = (projectId) => {
  // Fetch function for warehouses
  const fetchWarehouses = async ({ pageParam, pageSize, searchTerm }) => {
    const response = await getWarehousesPaginated({
      pageNumber: pageParam,
      pageSize,
      searchString: searchTerm,
    });
    return response;
  };

  // Fetch function for users
  const fetchUsers = async ({ pageParam, pageSize, searchTerm }) => {
    const response = await getUsersConditional({
      pageNumber: pageParam,
      pageSize,
      filterValue: searchTerm,
      projectId: projectId || -1,
    });
    return response;
  };

  // Fetch function for categories
  const fetchCategories = async ({ pageParam, pageSize, searchTerm }) => {
    const response = await getCategories({
      pageNumber: pageParam,
      pageSize,
      searchString: searchTerm,
    });
    return response;
  };

  const fetchVendorAdditionalParams = useMemo(
    () => ({ sortBy: 'companyName', sort: 'asc' }),
    []
  );

  // Fetch function for vendors
  const fetchVendors = async ({ pageParam, pageSize, searchTerm }) => {
    const response = await getVendors({
      pageNumber: pageParam,
      pageSize,
      searchName: searchTerm,
      ...fetchVendorAdditionalParams,
    });
    return response;
  };

  // Transform warehouse data to dropdown option format
  const transformWarehouseOption = (wh) => ({
    value: wh.roomId,
    label: wh.roomName,
    batchwise: wh.batchwise,
  });

  // Transform category data to dropdown option format
  const transformCategoryOption = (category) => ({
    value: category.inventoryTypeId,
    label: category.inventoryType,
    // description: category.description,
  });

  // Transform user data to dropdown option format
  const transformUserOption = (user) => ({
    value: user.userId || user.uid || user.id || user.username || user.name || user.Name,
    label: user.name || user.Name || user.memberName || user.username,
  });

  // Transform user data to dropdown option format
  const transformUserOptionForFilter = (user) => ({
    value: user.uid,
    label: user.name || user.username,
  });

  // Transform vendor data to dropdown option format
  const transformVendorOption = (vendor) => {
    const vendorId = vendor.vendorId;
    const firstName = vendor.vendorFirstName || '';
    const lastName = vendor.vendorLastName || '';
    const companyName = vendor.companyName || '';
    const label =
      firstName || lastName
        ? `${firstName} ${lastName}`.trim()
        : 'Unnamed Vendor';
    return {
      value: vendorId,
      label: label,
      description: companyName,
      accountNumbers: vendor.accountNumbers || '',
      vendorFirstName: firstName,
      vendorLastName: lastName,
      companyName: companyName,
      billingAddress: { ...vendor.billingAddress },
      gstTreatment: vendor.gstTreatment,
      phoneNumber: vendor.phoneNumber,
      email: vendor.email,
      interState: vendor.interState,  
    };
  };

  // Error handler for fetch failures
  const handleFetchError = (errorMessage) => {
    window.triggerAlert({
      title: 'Error',
      type: 'error',
      message: errorMessage,
    });
  };
  return {
    fetchWarehouses,
    fetchCategories,
    fetchUsers,
    fetchVendors,
    handleFetchError,
    transformWarehouseOption,
    transformCategoryOption,
    transformUserOption,
    transformUserOptionForFilter,
    transformVendorOption,
    fetchVendorAdditionalParams,
  };
};

export default usePODropdowns;
